export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/graphics_for_streamers.11051ba.svg";